import { IconButton, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArrowRotateLeft } from "@fortawesome/sharp-light-svg-icons";
import { Alert } from "../Alert/Alert";

library.add(faArrowRotateLeft);

interface BackendFailureAlertProps {
  message?: string;
  retryFunction?: () => void;
}

export const BackendFailureAlert = ({ message, retryFunction }: BackendFailureAlertProps) => {
  return (
    <Alert
      severity="error"
      action={
        retryFunction ? (
          <IconButton
            aria-label={"retry"}
            color={"inherit"}
            type={"button"}
            size={"small"}
            onClick={retryFunction}
          >
            <FontAwesomeIcon icon={faArrowRotateLeft} fontSize="inherit" />
          </IconButton>
        ) : null
      }
    >
      <Typography variant={"body3"}>{message ?? "An unexpected error has occurred."}</Typography>
    </Alert>
  );
};
